export default __webpack_public_path__ + "static/gatsby_deploy_select_ghpages-b3dbb1076833181b42de70b1e24791cd.png";